// Browser mirror of backend-merged/services/comparisonBooleanDisplay.js and its
// full-word token contract. Admin is built independently of the backend; the
// ProductAEOViewer rendering suite checks parity against that runtime contract.
const LABELS: Record<string, { yes: string; no: string }> = {
  ca: { yes: 'Sí', no: 'No' },
  da: { yes: 'Ja', no: 'Nej' },
  de: { yes: 'Ja', no: 'Nein' },
  el: { yes: 'Ναι', no: 'Όχι' },
  en: { yes: 'Yes', no: 'No' },
  es: { yes: 'Sí', no: 'No' },
  fi: { yes: 'Kyllä', no: 'Ei' },
  fr: { yes: 'Oui', no: 'Non' },
  it: { yes: 'Sì', no: 'No' },
  ja: { yes: 'はい', no: 'いいえ' },
  ko: { yes: '예', no: '아니요' },
  nl: { yes: 'Ja', no: 'Nee' },
  no: { yes: 'Ja', no: 'Nei' },
  pl: { yes: 'Tak', no: 'Nie' },
  pt: { yes: 'Sim', no: 'Não' },
  ru: { yes: 'Да', no: 'Нет' },
  sv: { yes: 'Ja', no: 'Nej' },
  zh: { yes: '是', no: '否' },
};

export function comparisonBooleanDisplay(value: unknown, language: string): string | undefined {
  const token = typeof value === 'string' ? value.trim().toLowerCase() : value;
  let boolean: boolean;
  if (token === true || token === 'true' || token === 'yes') boolean = true;
  else if (token === false || token === 'false' || token === 'no') boolean = false;
  else return undefined; // Not a Boolean: preserve numbers, abbreviations and prose.

  const lang = language.trim().toLowerCase().split(/[-_]/)[0];
  if (!Object.prototype.hasOwnProperty.call(LABELS, lang)) {
    throw Object.assign(new Error(`Unsupported language: ${language}`), {
      code: 'UNSUPPORTED_COMPARISON_LANGUAGE',
    });
  }
  return boolean ? LABELS[lang].yes : LABELS[lang].no;
}
